module.exports = __webpack_public_path__ + "img/链接6.cdb399e7.png";